import { Component, Input } from '@angular/core';
import { CAMAPANHA_ROI_KPI_RESULTADO } from '../../../campanha-roi-kpi';

@Component({
    selector: 'sgt-campanha-roi-widget-resultado',
    templateUrl: './campanha-roi-widget-resultado.component.html',
    styleUrls: ['./campanha-roi-widget-resultado.component.less']
})
export class CampanhaROIWidgetResultadoComponent {
    readonly KPI = CAMAPANHA_ROI_KPI_RESULTADO;

    @Input() isLoading: boolean;
    @Input() valorTotalResultado = 0;
}
